import { Box, BoxProps, ColorOptions, convertHexToRGBA, ModBox, SpacerNew, Text } from '@jfs/ui-new'
import { TextProps } from '@jfs/ui-new/src/comps/TextNew'
import { getStatusFromOrderApi, REFUND_INITIATED, simpleDateFormat } from '../../util/billPaymentUtil'
import { Colors } from '../../util/util'
import { Logo } from './Logo'

export const TransactionCard = ({ item, onSelect }: any) => {
  const txn = JSON.parse(JSON.stringify(item))
  let paymentDate = txn?.payment?.paymentAt
  if (paymentDate && paymentDate !== 'NA') {
    const paymentDateCopy: Date = new Date(paymentDate)
    const dd_mm_yyy = simpleDateFormat(paymentDateCopy, 'dd MMM yyyy,')
    const paymentDate1 = paymentDateCopy.toLocaleString('en-IN', { hour: 'numeric', minute: 'numeric', hour12: true })
    paymentDate = `${dd_mm_yyy} ${paymentDate1}`
    // const simple = simpleDateFormat(paymentDateCopy, 'dd MMM yyyy, hh:mm aaa')
    // paymentDate = simple
    // console.log('date', txn?.payment?.paymentAt, paymentDate)
  }
  let amount = txn?.payment?.amountDetails?.netAmount

  let status = getStatusFromOrderApi(txn)
  return (
    <Box
      underlayColor={'TRANSPARENT'}
      {...styles.myBillsCardViewWrapper}
      testID="billpay-txn-list"
      onPress={() => onSelect(txn)}>
      <Box flex={0.7} flexDirection={'row'}>
        <Box
          marginRight={16}
          borderRadius={20}
          width={40}
          height={40}
          justifyContent="center"
          alignItems={'center'}
          bg={convertHexToRGBA(Colors.SECONDARY, 8) as ColorOptions}
          overflow="hidden">
          <Logo logo={txn?.logoPath} type={'medium'} fallbackImageName={'RupeeTabIcon'} />
          {/* <Image
            source={txn?.logoPath}
            width={40}
            height={40}
            fallbackImage={require('../../assets/images/imagePlaceHolder.png')}
          /> */}
        </Box>
        <Box flex={1}>
          <Text
            fontSize={14}
            numberOfLines={1}
            ellipsizeMode={'tail'}
            letterSpacing={-0.07}
            lineHeight={20}
            color={Colors.BLACK_14 as ColorOptions}
            fontFamily="JioType-Medium">
            {txn?.product?.name}
          </Text>
          <SpacerNew size={2} direction={'vertical'} />
          <Text fontSize={12} lineHeight={16} color={Colors.PRIMARY_GREY} fontFamily="JioType-Medium">
            {paymentDate ? paymentDate : 'NA'}
          </Text>
        </Box>
      </Box>
      <Box alignItems="flex-end" flex={0.3}>
        <Text fontSize={14} lineHeight={20} fontFamily="JioType-Bold" color={Colors.BLACK_14 as ColorOptions}>
          {'₹' + amount ?? 'NA'}
        </Text>
        <ModBox>
          <Text
            fontSize={10}
            numberOfLines={1}
            lineHeight={16}
            fontFamily="JioType-Bold"
            {...styles.getStatusColor(status)}>
            {status === REFUND_INITIATED ? 'REFUND INITIATED' : status}
          </Text>
        </ModBox>
      </Box>
    </Box>
  )
}

const styles = {
  myBillsCardViewWrapper: {
    flexDirection: 'row',
    pv: 18,
    alignItems: 'center',
    // marginVertical: 10,
    mt: 0,
  } as BoxProps,
  getStatusColor: (status: any) => {
    let textColor = 'TEXT_PENDING' as ColorOptions
    if (status === 'SUCCESS') {
      textColor = 'TEXT_SUCCESS'
    } else if (status === 'FAILED') {
      textColor = 'TEXT_ERROR'
    } else if (status === 'REFUND_INITIATED') {
      textColor = '#c90fb6' as ColorOptions
    }
    const style = {
      color: textColor as ColorOptions,
    } as TextProps
    return style
  },
}
